import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReleaseNotesVersionLookupComponent } from './release-notes-version-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ReleaseNotesVersionLookupComponent],
  exports: [ReleaseNotesVersionLookupComponent]
})
export class ReleaseNotesVersionLookupModule { }
